module.exports = __webpack_public_path__ + "img/ring_r_o_0_null@3x.6b979380.png";